/**
 * Created by jinm on 2018. 9. 20..
 */
import React, { Component } from 'react';

import FunctionBased from '../components/FunctionBased';
import ProductBased from '../components/ProductBased';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import RightMenu from '../components/RightMenu';
import SweetAlert from 'sweetalert-react';
import BackBtn from '../img/arrow.png';
import * as requestLib from '../lib/requestLib';

export default class AdvancedSearch extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: 'FunctionBased',
			viewMenu: false,
			userName: '',
			permissionAlert: false,
		};
		this.baseUrl = requestLib.getUrl();
	}

	getCookie(name) {
		let value = '; ' + document.cookie;
		let parts = value.split('; ' + name + '=');
		if (parts.length == 2) return parts.pop().split(';').shift();
	}

	componentDidMount() {
		let accessToken = this.getCookie('accessToken');
		let url = window.location.href;
		if (url.indexOf('localhost') !== -1) {
			accessToken = '4276a4767834093a95444c2cdb5657f9d8672e2add97aa023a6418fc68fc285c';
		}
		$.ajax({
			url: this.baseUrl + 'api/Group/getUserPayInfo',
			data: { userToken: accessToken },
			method: 'get',
			dataType: 'json',
			success: function (response) {
				if (response.status === false || response.data.search_permission === false) {
					this.setState({ permissionAlert: true });
				} else {
					this.setState({ userName: response.data.lastName });
				}
			}.bind(this),
			error: function (e) { }.bind(this),
		});
	}

	changeTab(tabName) {
		this.setState({
			activeTab: tabName,
		});
	}

	menuToggle() {
		this.setState({ viewMenu: !this.state.viewMenu });
	}

	render() {
		let searchComponent = null;
		if (this.state.activeTab === 'FunctionBased') searchComponent = <FunctionBased />;
		else if (this.state.activeTab === 'ProductBased') searchComponent = <ProductBased />;

		return (
			<div id="advancedSearch">
				<SweetAlert
					show={this.state.permissionAlert}
					title="Sorry. You do not have permission."
					text=""
					onConfirm={() => {
						this.setState({ permissionAlert: false });
						window.location = this.baseUrl + 'main';
					}}
				/>
				<header>
					<div className="logo">
						<a href={this.baseUrl + 'main'}>
							<img src="//pro.mimic.us/assets/img/logo.svg" />
						</a>
					</div>
					<div className="menu-wrapper">
						<div className="profileBtn">
							<i className="fas fa-user-circle"></i>
							<span>{this.state.userName}</span>
							<div id="userMenu">
								<ul>
									<li>
										<a href={this.baseUrl + 'setting'}>setting</a>
									</li>
									<li>
										<a href={this.baseUrl + 'sse/user/logout'}>logout</a>
									</li>
								</ul>
							</div>
							{/*<a href="//pro.mimic.us/sse/user/login">*/}
							{/*<i className="fas fa-user-circle"></i>*/}
							{/*<span>Sign in</span>*/}
							{/*</a>*/}
						</div>
						<button
							className={this.state.viewMenu ? 'menuBtn menuShow' : 'menuBtn'}
							onClick={this.menuToggle.bind(this)}
						>
							<ul>
								<li />
								<li />
								<li />
							</ul>
						</button>
					</div>

					<RightMenu show={this.state.viewMenu ? 'true' : 'false'} />
				</header>
				<div className="advancedSearchWrap wrap">
					<div className="wrap1120">
						<a href="javascript:history.back();" className="back-btn">
							<img src={BackBtn} />
						</a>
						<h2>Search Scenario Card</h2>
						<div>
							<Tabs changeTab={(tabName) => this.changeTab(tabName)} />
							{searchComponent}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

class Tabs extends Component {
	constructor(props) {
		super(props);

		this.state = {
			viewMenu: 'FunctionBased',
		};
	}

	changeTab(tabName) {
		this.props.changeTab(tabName);
	}

	render() {
		return (
			<ul className="scenarioCard" id="scenarioCards">
				<ReactTooltip id="FunctionBasedSearch" place="bottom" type="light" effect="float">
					<span>
						Function-based Search lets you
						<br /> look for creatures with a particular
						<br /> function.
					</span>
				</ReactTooltip>
				<ReactTooltip id="productBasedSearch" place="bottom" type="light" effect="float">
					<span>
						Product-based Search can help you
						<br /> to look for biological organisms suitable
						<br /> for your product-system.
					</span>
				</ReactTooltip>
				<li
					id="FunctionBasedSearch"
					className={this.state.viewMenu === 'FunctionBased' ? 'active' : ''}
					data-tip
					data-for="FunctionBasedSearch"
					onClick={() => {
						this.changeTab('FunctionBased');
						this.setState({ viewMenu: 'FunctionBased' });
					}}
				>
					Function-based
					<br /> Search
				</li>
				<li
					id="productBasedSearch"
					className={this.state.viewMenu === 'ProductBased' ? 'active' : ''}
					data-tip
					data-for="productBasedSearch"
					onClick={() => {
						this.changeTab('ProductBased');
						this.setState({ viewMenu: 'ProductBased' });
					}}
				>
					Product-based
					<br /> Search
				</li>
				<li id="InOutputSearch">
					Input/Output
					<br />
					-oriented Search
				</li>
				<li id="VisualSearch">
					Visual
					<br />
					Search
				</li>
				<li id="StateChangeSearch">
					State Change
					<br />
					based Search
				</li>
				<li>
					+ Add a<br />
					Customized Search
				</li>
			</ul>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/AdvancedSearch.js